import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import Services from '../../services';
import { V2_FORGOT_PASSWORD_URL } from '../../consts/api';
import { isResponseSuccess } from '../../helpers';
import InputField from 'customField/InputField';
import { validationForgotPassword } from 'consts/validateSchema';
import { useHistory } from 'react-router';
import NewDesign from 'components/NewDesign';
import { AppRoutes } from 'consts/routesPath';
import { notifySuccess } from 'helpers/handleNotification';
import useResponsive from 'hooks/useResponsive';

const initialValues = {
  email: '',
};

const ForgotPassword = () => {
  //!State
  const [state, setState] = useState({
    success: false,
    error: null,
  });
  const { error, success } = state;
  const history = useHistory();
  const { isMobile } = useResponsive();

  //! Function
  const handleOnSubmit = async (values, { setSubmitting }) => {
    setState((prev) => ({ ...prev, error: null }));
    try {
      const res = await Services.post(V2_FORGOT_PASSWORD_URL, values);
      if (isResponseSuccess(res.status) && res.data && res.data.status === 'success') {
        setState((prev) => ({ ...prev, success: true }));
        notifySuccess('Request success. Please check your email.', 'Success');
      } else {
        throw Error(res?.data?.error?.error || 'No response');
      }
    } catch (error) {
      try {
        setState((prev) => ({ ...prev, error: JSON.parse(error).error }));
      } catch (e) {
        setState((prev) => ({ ...prev, error: error.toString() }));
      }
    }

    setSubmitting(false);
  };

  //! Render
  return (
    <div className='component:ForgotPassword p-3 d-flex justify-content-center align-items-center flex-column h-100 bg-color-white'>
      <Formik
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={handleOnSubmit}
        initialValues={initialValues}
        validationSchema={validationForgotPassword}
      >
        {({ isSubmitting }) => {
          return (
            <Form
              className='d-flex flex-column gap-8px'
              style={{ minWidth: isMobile ? '98%' : 600 }}
            >
              <NewDesign.Typography component='h3'>Forgot Password</NewDesign.Typography>

              <NewDesign.Typography component='p' className='mb-2'>
                Please enter your email address below and we will send you a link to reset your
                password.
              </NewDesign.Typography>

              <div className=' justify-content-center gap-8px flex-column w-100-div-1'>
                <Field
                  name='email'
                  type='email'
                  component={InputField}
                  label='Email'
                  required
                  placeholder='Input your email'
                  autoFocus
                />
              </div>

              {success && (
                <NewDesign.Alert color='success' className='mb-0'>
                  Request success. Please check your email.
                </NewDesign.Alert>
              )}

              {error && (
                <NewDesign.Alert className='mb-0' color='danger'>
                  {error}
                </NewDesign.Alert>
              )}

              <div className='d-flex gap-5px flex-column w-100-div-1'>
                <NewDesign.Button
                  type='submit'
                  className='w-100-div-1'
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                >
                  Submit
                </NewDesign.Button>
                <NewDesign.Button
                  type='button'
                  className='w-100-div-1'
                  disabled={isSubmitting}
                  onClick={(e) => {
                    e.preventDefault();
                    history.push(AppRoutes.Login);
                  }}
                  outline
                >
                  Back to login
                </NewDesign.Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ForgotPassword;
